import { TableHead } from '@/components/Datatable/TableHead';
import { SortableTableHeadersProps } from '@/type/listing.types';

export const UserTableHeaders = ({ t, onSort }: SortableTableHeadersProps) => {
  return (
    <>
      <TableHead
        text={t('common:users')}
        thClassName="min-w-[300px]"
        sortable
        onSortClick={() => onSort?.('userFullName')}
      />
      <TableHead
        text={t('common:status')}
        thClassName="text-center min-w-0 w-0"
      />
      <TableHead text={t('common:groups')} thClassName="min-w-[200px]" />
      <TableHead
        text={t('common:email')}
        thClassName="min-w-[230px]"
        sortable
        onSortClick={() => onSort?.('userEmail')}
      />
      <TableHead text={t('common:inspections')} thClassName="min-w-0 w-0" />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
